<mat-sidenav-container class="sidenav-container">
    <mat-sidenav class="menu" opened="{{isAuthenticated()}}" mode="side">
        <span class="title">SOCIABLE</span>
        <mat-nav-list class="menu-list" [disableRipple]="true">
            <ul class="menu-group">
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/dashboard'" class="item"
                        routerLinkActive="active-link">Dashboard</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/alerts'" class="item"
                        routerLinkActive="active-link">Alerts</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/node-manager'" class="item"
                        routerLinkActive="active-link">Node manager</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/updates'" class="item"
                        routerLinkActive="active-link">Updates</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/backup-schedules'" class="item"
                        routerLinkActive="active-link">Backup Schedules</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/backup-devices'" class="item"
                        routerLinkActive="active-link">Storage Devices</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated() && isAdmin()" [routerLink]="'/user-management'" class="item"
                        routerLinkActive="active-link">Users</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/block-ip'" class="item"
                        routerLinkActive="active-link">Block ip</a>
                </li>
                <li>
                    <a *ngIf="isAuthenticated()" [routerLink]="'/protection-policies'" class="item"
                        routerLinkActive="active-link">Protection Policies</a>
                </li>
                <li>
                    <a *ngIf="!isAuthenticated()" [routerLink]="'/login'" class="item"
                        routerLinkActive="active-link">Login</a>
                </li>
            </ul>
            <ul class="menu-group">
                <li>
                    <a *ngIf="isAuthenticated()" (click)="askLogout()" class="item"
                        routerLinkActive="active-link">Logout</a>
                </li>
            </ul>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="content" #matSideNavContent>
        <div *ngIf="isAuthenticated()" class="app-header">
            <span [ngClass]="{'pointer': !!getBreadcrumbRedirect()}" (click)="redirectToBreadcrumb()"
                (keydown)="redirectToBreadcrumb()" *ngIf="!!getBreadCrumb()">

                / {{getBreadCrumb()}}&nbsp;
            </span>
            <span *ngIf="!!getView()">
                / {{getView()}}
            </span>
        </div>
        <div class="content-box">
            <router-outlet></router-outlet>
        </div>
        <div class="finance-banner">
            <img src="/assets/images/BandaLogos_MTDFGob_DETID_PRTR_INCIBE.png"
                alt="Logos of MTDFGob, DETID, PRTR, and INCIBE">
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
<app-load-indicator></app-load-indicator>